import React from 'react';

import { Table } from '@block-explorer/ui';
import { TableRowType, useMatchMedia } from '@make-software/cspr-ui';

import HomeValidatorListHeaders from './HomeValidatorListHeaders';
import HomeValidatorListItem from './HomeValidatorListItem';
import { useGetValidatorsEraData } from '../../../hooks/event-store-hooks';
import { TableLoader } from '../../../components/page-data-table/table-loader';
import { useGetLastBlockInfo } from '../../../hooks';
import { sortByVerifiedValidators } from '../../../hooks/calculate-sorted-validators';
import { getValidatorWithInfo } from '../../../hooks/get-validator-data';

export interface HomeValidatorListProps {}

export const HomeValidatorList = (props: HomeValidatorListProps) => {
  const rowsPerPage = useMatchMedia([5, 8, 12], []);

  const { data: lastBlock } = useGetLastBlockInfo();
  const eraId = lastBlock?.era_id;

  const { data: validators, loading: validatorsLoading } =
    useGetValidatorsEraData(
      eraId
        ? {
            era_id: eraId,
            includes: 'account_info,average_performance',
            page_size: rowsPerPage,
          }
        : null
    );

  if (validatorsLoading || !validators) {
    return (
      <Table
        renderDataHeaders={() => <HomeValidatorListHeaders />}
        renderData={() => (
          <TableLoader
            columnsLength={4}
            rowsLength={rowsPerPage}
            tableRowType={TableRowType.TextWithAvatar}
          />
        )}
      />
    );
  }

  const validatorsWithInfo = getValidatorWithInfo({
    validators: validators || [],
  });

  const sortedValidators = sortByVerifiedValidators(
    validatorsWithInfo,
    'totalStakeAmount'
  );

  return (
    <Table
      renderDataHeaders={() => <HomeValidatorListHeaders />}
      renderData={() =>
        sortedValidators.map((validator, index) => (
          <HomeValidatorListItem
            key={validator?.key || index}
            data={validator}
          />
        ))
      }
    />
  );
};

export default HomeValidatorList;
